import { Navigate, Outlet } from 'react-router-dom'
import { ROUTES } from '@/config/routes'
import { useCurrentUser } from '@/features/auth/state/auth'
import { hasUserAddress } from '@/features/auth/utils/has-user-address'

export function AuthGate() {
  const user = useCurrentUser()

  // 1) Não logado
  if (!user) return <Navigate to={ROUTES.SIGNIN.path} replace />

  // 2) Não aceitou termos
  if (user.li_aceito === false) return <Navigate to={ROUTES.TERMS_OF_USE.path} replace />

  // 3) Sem CEP
  if (!hasUserAddress(user) ) {
    return <Navigate to={ROUTES.CEP.path} replace />
  }

  // 5) OK: libera rota alvo
  return <Outlet />
}
